export default {
  // Grey general note (restored per PM video) — the full one-per-order rule, shown on the
  // offer sheet and the promo/gift modal. Automatic discounts (smart pricing) still stack.
  general_note:
    'Kody promocyjne i karty podarunkowe nie mogą być łączone z innymi zniżkami. Oferta i wymiana punktów mogą być używane jednocześnie. Automatyczne rabaty, takie jak zniżka za odbiór, nadal obowiązują.',
  // Full note — offer detail sheet + promo/gift entry (CTO shortened to one line, 2026-07-31).
  full_note: 'Kody promocyjne i karty podarunkowe nie mogą być łączone z innymi zniżkami.',
  // Green status pill on the offer sheet when the offer's requirement is met (prototype).
  unlocked: 'Odblokowano',
  // Short static exclusion note per surface (card footers, CTO-confirmed copy).
  footer: {
    offer: 'Nie można łączyć z kodami promocyjnymi ani kartami podarunkowymi.',
    promo: 'Nie można łączyć z ofertami, kartami podarunkowymi ani punktami.',
    gift: 'Nie można łączyć z ofertami, kodami promocyjnymi ani punktami.',
  },
  // State-aware conflict line — names the discount that will be displaced.
  // Full mutual exclusivity (PM video): offer, promo, gift and points all block each other.
  conflict: {
    offer_blocked_by_promo: 'Zastosowano kod promocyjny. Użycie tej oferty spowoduje jego usunięcie.',
    offer_blocked_by_gift: 'Zastosowano kartę podarunkową. Użycie tej oferty spowoduje jej usunięcie.',
    offer_blocked_by_points: 'Aktywna jest wymiana punktów. Użycie tej oferty spowoduje jej usunięcie.',
    promo_gift_displaces_offer: 'Zastosowanie kodu promocyjnego lub karty podarunkowej usunie aktywną ofertę.',
    promo_gift_displaces_points: 'Zastosowanie kodu promocyjnego lub karty podarunkowej usunie wymianę punktów.',
    promo_gift_displaces_offer_and_points:
      'Zastosowanie kodu promocyjnego lub karty podarunkowej usunie aktywną ofertę i wymianę punktów.',
  },
  // Comparison-choice card (Inc 4, FOO-2567) — offer / promo detail modals when a conflicting
  // discount is already applied. Lets the customer pick, flagging the higher saving as best.
  comparison: {
    active_line: '{{kind}} jest już w użyciu: {{name}} ({{saving}}).',
    active_line_no_saving: '{{kind}} jest już w użyciu: {{name}}.',
    candidate_line: '{{kind}} oszczędza {{saving}}.',
    only_one: 'Można użyć tylko jednego.',
    best_choice: 'Najlepszy wybór',
    keep: 'Zachowaj {{label}}',
    use_instead: 'Użyj {{label}} zamiast',
    kinds: {
      offer: 'oferta',
      promo: 'kod promocyjny',
      gift: 'karta podarunkowa',
      points: 'wymiana punktów',
    },
    // Concise nouns for the Keep/Use buttons ("Keep offer", "Use code instead").
    button_kinds: {
      offer: 'oferta',
      promo: 'kod',
      gift: 'karta podarunkowa',
      points: 'punkty',
    },
    // Single-action variant (offer modal, promo/gift already active): one sentence + only the
    // "Use offer instead" button — closing the window keeps the code (CTO 2026-08-03).
    single_message:
      '{{active}} jest już w użyciu. Na jedno zamówienie można użyć tylko jednej zniżki — użyj tej oferty lub zamknij to okno, aby zachować kod.',
    active_named: {
      promo: 'Kod promocyjny {{name}} ({{saving}})',
      gift: 'Karta podarunkowa ({{saving}})',
    },
    active_named_no_saving: {
      promo: 'Kod promocyjny {{name}}',
      gift: 'Karta podarunkowa',
    },
    // Multiple active offers (item 6) — promo modal comparison, replaces the active/candidate lines.
    active_offers_two:
      'Masz {{count}} aktywnych ofert: {{first}} ({{firstValue}}) i {{second}} ({{secondValue}}) — razem {{total}}. Kod promocyjny {{code}} daje rabat {{codeValue}} na to zamówienie. Można użyć tylko jednej.',
    active_offers_more:
      'Masz {{count}} aktywnych ofert: {{first}} ({{firstValue}}), {{second}} ({{secondValue}}) i {{more}} więcej — razem {{total}}. Kod promocyjny {{code}} daje rabat {{codeValue}} na to zamówienie. Można użyć tylko jednej.',
  },
  // Discount-card status tag (deals carousel — offer + promo cards), Inc 3.
  card: {
    available: 'Dostępne teraz',
    applied: 'Zastosowano · {{savings}} rabatu',
    applied_plain: 'Zastosowano',
    replaces: 'Nie można łączyć z {{label}} · Zastępuje {{name}}',
    replaces_no_name: 'Nie można łączyć z {{label}}',
    // Prototype card treatment (blocked-by-conflict): a warning line naming the active discount,
    // the one-per-order note, and a "Replaces …" line.
    cannot_combine: 'Nie można łączyć z {{name}}',
    replaces_name: 'Zastępuje {{name}}',
    // Multiple active offers (n>1) — show a count + total instead of a single offer name (item 6).
    cannot_combine_offers: 'Nie można łączyć z {{count}} aktywnymi ofertami',
    replaces_offers: 'Zastępuje {{count}} aktywnych ofert ({{total}})',
    // Generic type label for the active discount that would be displaced.
    kind: {
      offer: 'ofertę',
      promo: 'kod promocyjny',
      gift: 'kartę podarunkową',
      points: 'twoją wymianę punktów',
    },
  },
  // DisplacementNotice (cart drawer + checkout) — bidirectional & entity-named (PM video).
  // One discount displaced another; the message names both, and Undo restores the displaced one.
  // e.g. "Promo code CHEVERE applied. This removed the 2-für-1 offer. [Undo]".
  displacement: {
    message: 'Zastosowano {{applied}}. Usunięto {{removed}}.',
    // Multiple offers removed at once (item 6) — names the top two + the total, in cart + checkout.
    offer_removed_multi: {
      promo:
        'Zastosowano kod promocyjny {{code}} ({{codeValue}}). Usunięto {{count}} oferty: {{first}} i {{second}} ({{total}}).',
      gift: 'Zastosowano kartę podarunkową. Usunięto {{count}} oferty: {{first}} i {{second}} ({{total}}).',
    },
    undo: 'Cofnij',
    // The discount that is currently applied (the "winner").
    applied: {
      offer: 'Ofertę {{name}}',
      promo: 'Kod promocyjny {{code}}',
      gift: 'Karta podarunkowa',
      points: '{{count}} punktów',
    },
    // The discount that was displaced (the "loser"), restored by Undo.
    removed: {
      offer: 'ofertę {{name}}',
      promo: 'kod promocyjny {{code}}',
      gift: 'kartę podarunkową',
      points: 'twoją wymianę punktów',
    },
    // UX feedback item 3 — points redemption displacing a promo/gift. Layer A: a zero-friction hint
    // under the "Use your points" header, shown only while a code/gift is active (before they tap).
    points_hint: {
      promo: 'Użycie punktów usunie kod promocyjny {{name}} (–{{saving}})',
      gift: 'Użycie punktów usunie kartę podarunkową (–{{saving}})',
      promo_no_saving: 'Użycie punktów usunie kod promocyjny {{name}}',
      gift_no_saving: 'Użycie punktów usunie kartę podarunkową',
    },
    // Layer B: the post-action displacement notice, extended to the points→code direction.
    points_displaced: {
      promo:
        'Zastosowano {{points}} punktów (–{{pointsSaving}}). Kod promocyjny {{name}} (–{{couponSaving}}) został usunięty.',
      gift: 'Zastosowano {{points}} punktów (–{{pointsSaving}}). Karta podarunkowa (–{{couponSaving}}) została usunięta.',
      promo_no_saving: 'Zastosowano {{points}} punktów (–{{pointsSaving}}). Kod promocyjny {{name}} został usunięty.',
      gift_no_saving: 'Zastosowano {{points}} punktów (–{{pointsSaving}}). Karta podarunkowa została usunięta.',
    },
  },
};
